module.exports = __webpack_public_path__ + "img/no-glasses.66944870.png";